import { AppRouteProps } from "@bsm/component";
import React from "react";
import { AboutUserDetailsRoutes } from "./views/about/AboutUserDetailsRoutes";
import { ParamsUserDetailsRoutes } from "./views/params/ParamsStudentDetailsRoutes";

const StudentDetailsContainer = React.lazy(() => import('./containers/StudentDetailsContainer'))

export const StudentDetailsRoutes: Array<AppRouteProps> = [
    {
        path: 'students/:id',
        title: '{{StudentNameFull}}',
        element: <StudentDetailsContainer />,
        roles: ['STUDENT'],
        children: [
            ...AboutUserDetailsRoutes,
            ...ParamsUserDetailsRoutes,
        ]
    }
]